<template>
  <div 
    v-if="background.videoLayer && background.video.mp4"
    class="video-layer"
    data-tag="BaseBackground"
    :data-mp4-src="background.video.mp4"
    >
    <video :key="background.video.mp4" autoplay muted loop v-if="! $isServer">
      <source :src="background.video.mp4" type="video/mp4">
    </video>
  </div>
</template>

<script>
export default {
	props: {
    background: Object,
    default() {
      return {}
    }
  }
}

</script>

<style>
.video-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0 !important;
}

.video-layer > video {
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

</style>